export const addFolderFilter = (folder: string, filters?: string): string =>
  JSON.stringify(
    filters
      ? {
          ...JSON.parse(filters),
          folder
        }
      : { folder }
  );
